// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"19ea0e6c","99":"270ef61d","288":"90ff2698","374":"89bca050","660":"2b89565c","710":"fe364be2","758":"b70a75d6"}[chunkId] + ".chunk.js";
};